import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../enums/queryKeys'
import { fetchPaymentMethods } from '../query-api/payment-methods-query'

interface UsePaymentMethodsProps {
  enabled?: boolean
}

export const usePaymentMethods = ({ enabled = true }: UsePaymentMethodsProps = {}) => {
  const { organization, isLoading: isOrganizationLoading } = useUserOrganization()
  const organizationId = organization?.id || ''

  const {
    data: paymentMethods,
    isLoading: isPaymentMethodsLoading,
    ...rest
  } = useQuery([QueryKeys.PaymentMethods, organizationId], () => fetchPaymentMethods(organizationId), {
    enabled: enabled && !!organizationId,
  })

  const isLoading = isOrganizationLoading || isPaymentMethodsLoading

  return { paymentMethods, isLoading, ...rest }
}
